import { DeployEnv } from '@patsnap-utils/biz';
import { REGION } from '@eureka/utils/environment';
import type { EditionType, PlanConfig } from '../types';

export const isSandBoxEnv = [DeployEnv.CI, DeployEnv.QA, DeployEnv.STAGE, DeployEnv.DEV].includes(REGION)
export const isOversea = [DeployEnv.US, DeployEnv.EU].includes(REGION)

/**
 * 套餐价格表
 */
export const PRICE_MAP: Record<EditionType, { priceId: string, billingCycle: 'monthly' | 'yearly' }[]> = {
    basic: [],
    rd_pro: [
        {
            priceId: isSandBoxEnv ? 'price_1SzTRt4BHjfY2tko9hRTn6lm' : 'price_1SwEDf3n4XHnBaSmUg6HxFZZ',
            billingCycle: 'monthly',
        },
        {
            priceId: isSandBoxEnv ? 'price_1SzTSA4BHjfY2tkodoZEejax' : 'price_1SzTsn3n4XHnBaSmadDrjQtL',
            billingCycle: 'yearly',
        }
    ],
    enterprise: [],
    api: [],
}

export const PLAN_CONFIG_MAP: Record<EditionType, PlanConfig> = {
    basic: {
        credits: 10,
        originalPrice: 0,
        salePrice: 0,
    },
    rd_pro: {
        credits: 100,
        originalPrice: 398,
        salePrice: 99,
        yearlyOriginalPrice: 1188, // 99 * 12
        yearlySalePrice: 999, // 199 * 10 (相当于优惠2个月)
        emergencyPackOriginalPrice: 25,
        emergencyPackSaleDiscount: 20,
        emergencyPackSalePrice: 20,
        projectPackOriginalPrice: 55,
        projectPackSalePrice: 44,
        projectPackSaleDiscount: 20,
    },
    enterprise: {
        credits: 100,
        originalPrice: 398,
        salePrice: 99,
        yearlyOriginalPrice: 4776, // 398 * 12
        yearlySalePrice: 199, // 199 * 10 (相当于优惠2个月)
        emergencyPackOriginalPrice: 25,
        emergencyPackSaleDiscount: 20,
        emergencyPackSalePrice: 20,
        projectPackOriginalPrice: 55,
        projectPackSalePrice: 44,
        projectPackSaleDiscount: 20,
    },
    api: {
        credits: 100,
        originalPrice: 398,
        salePrice: 99,
        yearlyOriginalPrice: 4776, // 398 * 12
        yearlySalePrice: 199, // 199 * 10 (相当于优惠2个月)
        emergencyPackOriginalPrice: 25,
        emergencyPackSaleDiscount: 20,
        emergencyPackSalePrice: 20,
        projectPackOriginalPrice: 55,
        projectPackSalePrice: 44,
        projectPackSaleDiscount: 20,
    },
}
